import { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

export const CookieConsent = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(() => !localStorage.getItem("lidlink-consent"));

  if (!visible) return null;

  const decide = (choice) => {
    localStorage.setItem("lidlink-consent", choice);
    setVisible(false);
  };

  return (
    <div data-testid="cookie-consent" className="fixed bottom-0 inset-x-0 z-[60] p-4 sm:p-5">
      <div className="max-w-3xl mx-auto bg-white border spec-border rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.12)] p-5 sm:flex sm:items-center sm:gap-6">
        <p className="text-xs text-slate-600 leading-relaxed flex-1">
          {t.consent.text}{" "}
          <Link to="/datenschutz" className="text-blue-700 underline hover:text-blue-800">
            {t.consent.learn}
          </Link>
        </p>
        <div className="mt-4 sm:mt-0 flex gap-3 shrink-0">
          <button
            type="button"
            data-testid="cookie-reject"
            onClick={() => decide("rejected")}
            className="px-4 py-2 text-xs font-mono-spec font-semibold border spec-border rounded-full text-slate-700 hover:bg-slate-50 transition-colors"
          >
            {t.consent.reject}
          </button>
          <button
            type="button"
            data-testid="cookie-accept"
            onClick={() => decide("accepted")}
            className="px-4 py-2 text-xs font-mono-spec font-bold rounded-full bg-slate-950 text-white hover:bg-slate-800 transition-colors"
          >
            {t.consent.accept}
          </button>
        </div>
      </div>
    </div>
  );
};
